var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_vm._t("header",[_c('h4',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.header))]),_c('hr')]),_vm._t("body",[_c('div',[_vm._v(_vm._s(_vm.message))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }